

const data = [
	{
		'id':1,
		'sochial':'صفحة الفيسبوك',
		'des':'تواصل معنا عبر فيسبوك من خلال الصغط علي الزر التالي',
		'btn': <a className="btn btn-outline-primary col-12" href="https://www.facebook.com/saskecompany1/" target="_blank" rel="noreferrer">أضغط هنا</a>,
		'logo':<i className="bi bi-facebook"></i>,
	},
	{
		'id':2,
		'sochial':'تواصل معنا واتساب',
		'des':'يمكنك الأن التواصل مع أحد ممثلي خدمة العملاء الخاصين بنا من خلال الواتساب',
		'btn': <a className="btn btn-outline-success col-12" href="https://api.whatsapp.com/send?phone=201060950140&text='مرحباً توصلت إليكم من خلال معرض أعمال الشركه . هل يمكنكم مساعدتي ؟'" target="_blank" rel="noreferrer">أضغط هنا</a>,
		'logo': <i className="bi bi-whatsapp"></i>,
	},

	{
		'id':3,
		'sochial':'قناتنا علي اليوتيوب',
		'des':'للتعرف علينا اكثر يمكنك مشاهدة بعض من أعمالنا و محاضرتنا عبر قناتنا علي اليوتيوب',
		'btn': <a className="btn btn-outline-danger col-12" href="https://www.youtube.com/channel/UCBDkXi6dInbyXJIeofqxrGg" target="_blank" rel="noreferrer">أضغط هنا</a>,
		'logo':<i className="bi bi-youtube"></i>,
	},

	{
		'id':4,
		'sochial':'صفحة لينكد ان',
		'des':'تعرف علينا اكتر من خلال منصة الأعمال لينكد ان',
		'btn': <a className="btn btn-outline-primary col-12" href="https://www.linkedin.com/company/75406561" target="_blank" rel="noreferrer">أضغط هنا</a>,
		'logo':<i className="bi bi-linkedin"></i>,
	},

	{
		'id':5,
		'sochial':'مشاريعنا',
		'des':'إضغط علي الزر التالي للتعرف علي أخر مشاريعنا ',
		'btn': <a className="btn btn-outline-secondary col-12" href="https://github.com/saskecompany" target="_blank" rel="noreferrer">أضغط هنا</a>,
		'logo':<i className="bi bi-github"></i>,
	},

	{
		'id':6,
		'sochial':'اتصل بنا',
		'des':'إضغط علي الزر التالي للتواصل معنا مباشرة عبر الهاتف',
		'btn': <a className="btn btn-outline-secondary col-12" href="tel:01060950140" target="_blank" rel="noreferrer">أضغط هنا</a>,
		'logo':<i className="bi bi-phone"></i>,
	},

];


export default data;
